// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qx-1";
export var stateContainer = "_qx-0";